import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IRelationshipTypeDto } from '@/dtos';


const GET_RELATIONSHIP_TYPES_QUERY_KEY = 'getRelationshipTypesQueryKey';
export const useGetRelationshipTypesQuery = () => {
  const { data, isLoading } = useQuery([GET_RELATIONSHIP_TYPES_QUERY_KEY], () =>
    api.get<IRelationshipTypeDto[]>(API_URL.ENUMS_RELATIONSHIP_TYPES)
  );

  return {
    types: data?.data || [],
    isLoading,
  };
};
